'use strict';
/*
  Priority Claim & Replacement — added by default (opt-out), Australia only.
  - Auto-adds once there is at least one real product in the cart, only where the
    snippet is rendered (AU visitors) and only if the customer hasn't unticked it.
  - Unticking removes it and records the choice on the cart (_pcr_optout) so it is
    never re-added for that cart. Ticking again clears the opt-out.
  - Cart counts leave the protection line out (see protectionFreeCount in cart.js).
*/
(function () {
  if (window.__cartProtectionInit) return;
  window.__cartProtectionInit = true;

  const HANDLE = 'priority-claim-replacement';
  let busy = false;

  async function post(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error(url + ' failed');
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function refresh() {
    if (window.cartUi) window.cartUi.dispatchRefresh({ openDrawer: window.cartUi.isDrawerOpen() });
    else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} }));
  }

  function setOptout(value) {
    return post('/cart/update.js', { attributes: { _pcr_optout: value ? '1' : '' } });
  }

  document.addEventListener('change', async (event) => {
    const box = event.target.closest('[data-cart-protection-toggle]');
    if (!box) return;
    if (busy) {
      box.checked = !box.checked;
      return;
    }
    busy = true;
    const wrap = box.closest('[data-cart-protection]');
    if (wrap) wrap.classList.add('is-loading');
    try {
      if (box.checked) {
        await setOptout(false);
        if (!box.dataset.lineKey) {
          await post('/cart/add.js', { id: Number(box.dataset.variantId), quantity: 1 });
        }
      } else {
        await setOptout(true);
        if (box.dataset.lineKey) {
          await post('/cart/change.js', { id: box.dataset.lineKey, quantity: 0 });
        }
      }
      busy = false;
      refresh();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Cart protection toggle error:', err);
      box.checked = !box.checked;
      busy = false;
    } finally {
      if (wrap) wrap.classList.remove('is-loading');
    }
  });

  /* Keeps the cart consistent: auto-add (unless opted out), qty 1, remove if alone. */
  async function sync() {
    if (busy) return;
    busy = true;
    let changed = false;
    try {
      const cart = await getCart();
      const lines = cart.items || [];
      const prot = lines.find((l) => l.handle === HANDLE);
      const others = lines.filter((l) => l.handle !== HANDLE);
      const optedOut = (cart.attributes || {})._pcr_optout === '1';
      const widget = document.querySelector('[data-cart-protection]');

      if (prot && !others.length) {
        await post('/cart/change.js', { id: prot.key, quantity: 0 });
        changed = true;
      } else if (prot && prot.quantity !== 1) {
        await post('/cart/change.js', { id: prot.key, quantity: 1 });
        changed = true;
      } else if (!prot && others.length && !optedOut && widget) {
        await post('/cart/add.js', { id: Number(widget.dataset.variantId), quantity: 1 });
        changed = true;
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Cart protection sync error:', err);
    } finally {
      busy = false;
    }
    if (changed) refresh();
  }

  // cart.js fires cart:rendered after it swaps in fresh drawer / cart page HTML; the timer is a fallback
  // for a refresh whose render failed.
  document.addEventListener('cart:rendered', sync);
  document.addEventListener('cart:refresh', () => setTimeout(sync, 1500));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(sync, 300));
  } else {
    setTimeout(sync, 300);
  }
})();

/* Learn more expand/collapse (state kept across drawer re-renders, shared by drawer and cart page). */
(function () {
  if (window.__cartProtectionMoreInit) return;
  window.__cartProtectionMoreInit = true;

  let expanded = false;
  function apply() {
    document.querySelectorAll('[data-cart-protection]').forEach((widget) => {
      const btn = widget.querySelector('[data-cart-protection-more]');
      const panel = widget.querySelector('[data-cart-protection-details]');
      if (!btn || !panel) return;
      panel.hidden = !expanded;
      btn.setAttribute('aria-expanded', String(expanded));
      btn.textContent = expanded ? 'Show less' : 'Learn more';
    });
  }
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-cart-protection-more]')) return;
    event.preventDefault();
    expanded = !expanded;
    apply();
  });
  document.addEventListener('cart:rendered', apply);
})();
